<template>
    <a :href="profile" class="d-block">
        <div class="card card-filled card--blue">
            <div class="card__text h-100 justify-content-center">
                <div
                    class="card__image position-relative"
                    :style="profileImage"
                >
                    <span v-if="member.imageUrl == null" class="card__initials">
                        {{ member.initials }}
                    </span>
                </div>
                <h3 class="h2 font-weight-bold">
                    {{ fullName }}
                </h3>
                <ul class="list-unstyled font-italic">
                    <li>{{ member.company }}</li>
                    <li>{{ member.role }}</li>
                    <li>
                        <a
                            :href="'mailto:' + member.email"
                            class="color--white"
                            >{{ member.email }}</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        member: {
            type: Object,
            default() {
                return {};
            }
        },
        profile: {
            type: String,
            default() {
                return '';
            }
        }
    },
    computed: {
        profileImage() {
            return [
                this.member.imageUrl == null
                    ? {
                          'background-color': '#F5F4F5'
                      }
                    : {
                          'background-image':
                              'url(' + this.member.imageUrl + ')'
                      }
            ];
        },

        fullName() {
            return [
                this.member.firstname,
                this.member.middlename,
                this.member.lastname
            ]
                .filter(Boolean)
                .join(' ');
        }
    }
};
</script>

<style lang="scss" scoped>
.card__image {
    height: 140px;
    width: 140px;
    margin: 20px auto 50px auto;
    background-size: cover;
    background-position: center center;
    border-radius: 90px;
}
.card__initials {
    font-size: 48px;
}
</style>
